export const USERS_LIST = "PLATFORMS_PORTAL_USERS_LIST";
export const USERS_CREATE = "PLATFORMS_PORTAL_USERS_CREATE";
export const USERS_UPDATE = "PLATFORMS_PORTAL_USERS_UPDATE";
export const USERS_DELETE = "PLATFORMS_PORTAL_USERS_DELETE";
export const USERS_SHOW = "PLATFORMS_PORTAL_USERS_SHOW";
